import axios, { AxiosResponse } from 'axios';
import { SelectExtendedList } from 'src/components';
import { getMolecularCdnUrl } from '../get-molecular-cdn-url';
import { reportErrorSentry } from 'src/bff';

export interface CarlinesCitaResponse {
  content: SelectExtendedList[];
}

export const getCarlinesCita = async (isComerciales?: boolean): Promise<SelectExtendedList[]> => {
  const molecularCdn = getMolecularCdnUrl();
  const groupBrand = isComerciales ? 'N' : 'V';
  try {
    const response: AxiosResponse<CarlinesCitaResponse> = await axios.get(
      `${molecularCdn}/request-eapi-carlines.php?group_brand=${groupBrand}`
    );

    // Actualmente devuelve <html> 503 Service Temporarily... y no se detecta como error
    if (typeof response.data.content === 'string') {
      return null;
    }
    return response.data.content;
  } catch (error) {
    reportErrorSentry(error);
    return null;
  }
};
